import styles from "./InputFields.module.css";

interface InputFieldProps {
    customClassName?: string,
    labelText?: string,
    type: string, 
    name: string, 
    placeholder?: string, 
    value: string, 
    validationError?: boolean,
    validationErrorMessage?: string,
    handleChange: (event: React.ChangeEvent<HTMLInputElement>, args?: any) => void
    handleChangeArgs?: any
}


const InputField: React.FC<InputFieldProps> = (props) => {

    const {
        customClassName = "",
        labelText,
        type, 
        name, 
        placeholder, 
        value, 
        validationError,
        validationErrorMessage,
        handleChange,
        handleChangeArgs
    } = props;


    return (
        <div className = {`${styles.input_field} ${styles[customClassName]}`}>
            {labelText && <label>{labelText}</label>}
            <div className = {styles.input}>
                <input
                    type = {type}
                    name = {name}
                    placeholder = {placeholder}
                    value = {value}
                    onChange = {(event) => handleChange(event, handleChangeArgs)}
                />
            </div>
            {(validationError && !value) && <p>{validationErrorMessage}</p>}
        </div>
    );

}


export default InputField;